import PropTypes from "prop-types";
import { StarFill } from "@icons/star-fill";
import { StarEmpty } from "@icons/star-empty";
import styles from "./styles/summary.module.css";

export function Rating({ average, reviewSection, className, width = 20 }) {
  function renderStars() {
    const fullStars = Math.floor(average);
    const partialStar = average % 1;
    const emptyStars = 5 - Math.ceil(average);

    const stars = [];

    for (let i = 0; i < fullStars; i++) {
      stars.push(<StarFill key={i} width={width} />);
    }

    if (partialStar > 0) {
      stars.push(
        <div key="partial" className={styles.partialStarContainer} style={{ width, height: width }}>
          <StarEmpty width={width} />
          <div
            className={styles.partialStarFill}
            style={{ width: `${partialStar * 100}%`, height: "100%" }}
          >
            <StarFill width={width} />
          </div>
        </div>
      );
    }

    for (let i = 0; i < emptyStars; i++) {
      stars.push(<StarEmpty key={i + fullStars + 1} width={width} />);
    }

    return stars;
  }

  return (
    <span className={`${reviewSection ? `${styles["review-star"]} ${className}` : styles.star}`}>
      {renderStars()}
    </span>
  );
}

Rating.propTypes = {
  average: PropTypes.number.isRequired,
  reviewSection: PropTypes.bool,
  className: PropTypes.string,
  width: PropTypes.number,
};
